import { useState, useEffect } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";

import {
    capitalizeFirstLetter,
    getStatusDiscountTextColor,
    getStatusColorDiscount,
} from "../../utilz/function";

interface TransactionData {
    _id: string;
    transactionId: string;
    name: string;
    amount: string;
    date: string;
    status: string;
    description: string;
    paymentMethod: string;
}

interface TransactionTableProps {
    data: TransactionData[];
    selectedStatus?: string;
    handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const TransactionTable: React.FC<TransactionTableProps> = ({data, selectedStatus}) => {
    const navigate = useNavigate();
    const [filteredData, setFilteredData] = useState<TransactionData[]>([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [selectedType, setSelectedType] = useState("");

    const columns = [
        { header: "TransactionId", accessor: "transactionId" },
        { header: "Customer Name", accessor: "name" },
        { header: "Amount", accessor: "amount" },
        { header: "Description", accessor: "description" },
        { header: "Payment Method", accessor: "paymentMethod" },
        { header: "Status", accessor: "status" },
        { header: "Actions", accessor: "_id" },
    ];

    const handleUserClick = (_id: string) => {
        navigate(`/dashboard/transactions/${_id}`);
    };

    useEffect(() => {
        const filtered = data?.filter((transaction) => {
            // Use selectedType instead of selectedStatus
            const statusMatch = !selectedType || transaction?.status === selectedType;

            const searchMatch = 
             !searchQuery ||
                transaction?.name
                    ?.toLowerCase()
                    .includes(searchQuery?.toLowerCase())
        
            return statusMatch && searchMatch;
        })
        setFilteredData(filtered);
    }, [data, selectedType, searchQuery]); // Include selectedType in dependencies

    const combinedData = filteredData?.map((transaction) => ({
        ...transaction,
        status: (
            <p
                style={{
                    backgroundColor: getStatusColorDiscount(transaction?.status),
                    color: getStatusDiscountTextColor(transaction?.status),
                    }}
                    className="rounded-full px-2 py-1 text-sm"
            >
                {capitalizeFirstLetter(transaction.status)}
            </p>
        ),

        amount:(
            <p >
                ₦ {Number(transaction.amount).toLocaleString()}
            </p>
        )
    }))

    

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    const handleTransactionsFilterChange = (selectedValue: string) => {
        setSelectedType(selectedValue);
    };

    return ( 
        <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
            <div className="md:flex justify-between px-5">
                <p className="text-[20px] font-bold">Transaction</p>

                 <div className="md:flex gap-2 items-center md:mt-0 mt-2">
                    <Input
                        name="search"
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className="w-full"
                        placeholder="Search"
                        icon="searchIcon"
                    />

                    <FIlterSelect
                        name="status"
                        options={[
                        { value: "pending", label: "Pending" },
                        { value: "completed", label: "Completed" },
                        ]}
                        className="mt-2 md:-mt-2 w-full md:w-[50%]"
                        icon="filterIcon"
                        onChange={handleTransactionsFilterChange}
                        value={selectedType}
                    />
                </div>
            </div>

            {combinedData?.length > 0 ? (
                <Table
                columns={columns}
                data={combinedData}
                selectedUserId={null}
                onUserClick={handleUserClick}
                />
            ) : (
                <div className="opacity-80 mt-10 font-bold text-center mx-auto">
                No Transaction found
                </div>
            )}
        </div>
     );
}
 
export default TransactionTable;